<template>
  <div class="business-index">
    <website-header :setNum="4"></website-header>
    <div class="index-top" :style="`background-image:url('${imgURI + '/static/business/swhzbj.png'}');`">
      <!--      <div class="index-top-bor">-->
      <!--        <div class="display-flex tips-c">侃侃 让世界更懂你！</div>-->
      <!--        <div class="display-flex flex-column tips">-->
      <!--          <div class="bold">MAKE THE WORLD</div>-->
      <!--          <div class="font-weight-100">UNDERSTAND YOU BETTER</div>-->
      <!--        </div>-->
      <!--      </div>-->
    </div>
    <div id="online" class="def-width margin-center">
      <tips :tipsC="`线上资源优势`" :tipsE="`ONLINE RESOURCE ADVANTAGE`" :paddingTop="116" :paddingBottom="103"></tips>
      <div class="display-flex">
        <div>
          <img class="user" :src="`${imgURI}/static/business/tu1.png`"/>
        </div>
        <div class="online-right display-flex justify-content-center align-items-center">
          <div class="title bold letter-spacing-2">微信公域+私域</div>
          <div class="line"></div>
          <div class="description text-center color-979797 font-14">
            <div>主号：侃侃跨境那些事儿</div>
            <div>Moss的精神家园</div>
            <div>共计200+社群</div>
            <div>60W优质亚马逊卖家聚集媒体</div>
            <div>账号+社群全网覆盖用户触达2000W+</div>
          </div>
        </div>
      </div>
    </div>
    <div class="moss">
      <div style="width: 100%">
        <div class="moss-bor display-flex justify-content-center align-items-center">
            <div class="moss-ul display-flex font-14 color-979797">
              <div style="width: 1200px">
                <div class="title bold letter-spacing-2">跨境大V-Moss</div>
                <div class="line"></div>
                <div>
                  全网粉丝100W+
                </div>
                <div>
                  账户垂直度精准，流量粘性高
                </div>
                <div>
                  认可度高，品牌信任价值传递高
                </div>
              </div>
            </div>
            <div style="width: 446px"></div>
        </div>
      </div>
      <div class="moss-img">
        <img class="user" :src="`${imgURI}/static/about/mosstouxiang.png`"/>
      </div>
      <div class="clear"></div>
    </div>
    <div class="flow">
      <div class="color-979797 bold text-center">
        <div>覆盖全网流量大的平台</div>
        <div>图文+短视频+直播打造最专业的跨境自媒体团队</div>
      </div>
      <div class="def-width margin-center">
        <ul class="flow-list display-flex justify-content-center">
          <li v-for="(item,index) in flowList" :key="index">
            <img :src="`${imgURI}/static/business/${item.icon}`"/>
          </li>
        </ul>
      </div>
    </div>
    <div id="offline" class="def-width margin-center">
      <tips :tipsC="`线下资源优势`" :tipsE="`OFFLINE RESOURCE ADVANTAGE`" :paddingTop="0" :paddingBottom="0"></tips>
      <div class="msg-bor def-width margin-center">
        <div class="intro-carousel" style="float: left">
          <img :src="`${imgURI}/static/business/tu2.png`">
        </div>
        <div class="msg-bor-left" style="float: right;margin-top: -334px;">
          <div class="font-18 title bold">侃侃媒体矩阵全渠道曝光</div>
          <div class="line"></div>
          <div class="msg color-979797">
            线下多类型曝光呈现方式：背板x互动<br/>
            联合全行业媒体资源宣发：嘉宾x媒体
          </div>
        </div>
        <div class="clear"></div>
      </div>
      <div class="msg-bor def-width margin-center">
        <div class="msg-bor-left display-flex justify-content-center align-items-center" style="float: left">
          <div class="msg color-979797">
            垂直跨境领域主题活动类型丰富<br/>
            可参与多种不同类型活动依据观众画像精准获客体
          </div>
        </div>
        <div class="intro-carousel" style="float: right;margin-top: -328px;">
          <img :src="`${imgURI}/static/business/tu3.png`">
        </div>
        <div class="clear"></div>
      </div>
      <div class="msg-bor def-width margin-center">
        <div class="intro-carousel" style="float: left">
          <img :src="`${imgURI}/static/business/tu4.png`">
        </div>
        <div class="msg-bor-left display-flex justify-content-center align-items-center" style="float: right;margin-top: -334px;">
          <div class="msg color-979797">
            1v多，行业资源一站式链接<br/>
            参与市场人多类型体验活动<br/>
            深度同频交流，拓展渠道资源
          </div>
        </div>
        <div class="clear"></div>
      </div>
      <div id="cooperation">
        <tips :tipsC="`合作范围`" :tipsE="`SCOPE OF COOPERATION`" :paddingTop="183" :paddingBottom="80"></tips>
        <div class="scope display-flex justify-content-center">
          <div class="scope-one display-flex justify-content-center">
            <div>
              短视频
            </div>
            <div>
              营销
            </div>
          </div>
          <div class="scope-one display-flex justify-content-center">
            <div>
              直播
            </div>
            <div>
              营销
            </div>
          </div>
          <div class="scope-one display-flex justify-content-center">
            <div>
              账号
            </div>
            <div>
              代运营
            </div>
          </div>
          <div class="scope-one display-flex justify-content-center">
            <div>
              线上
            </div>
            <div>
              课程
            </div>
          </div>
        </div>
        <div class="scope display-flex justify-content-center scope-other">
          <div class="scope-one display-flex justify-content-center">
            <div>
              内容
            </div>
            <div>
              营销
            </div>
          </div>
          <div class="scope-one display-flex justify-content-center">
            <div>
              社群
            </div>
            <div>
              营销
            </div>
          </div>
          <div class="scope-one display-flex justify-content-center">
            <div>
              小型
            </div>
            <div>
              沙龙会
            </div>
          </div>
          <div class="scope-one display-flex justify-content-center">
            <div>
              大型
            </div>
            <div>
              峰会
            </div>
          </div>
          <div class="scope-one display-flex justify-content-center">
            <div>
              知识IP
            </div>
            <div>
              孵化
            </div>
          </div>
        </div>
      </div>
      <div id="process">
        <tips :tipsC="`合作流程`" :tipsE="`COLLABORATION PROCESS`" :paddingTop="183" :paddingBottom="80"></tips>
        <ul class="process-ul display-flex flex-wrap text-center">
          <li v-for="(item, index) in processList" :key="index">
            <img :src="`${imgURI}/static/business/${item.icon}`">
            <div class="font-20 color-292C2E">{{item.title}}</div>
          </li>
        </ul>
      </div>
      <div>
        <div>
          <div class="website-index-tips text-center">
            <span class="tips-about bold color-1E1E1E">CASE PRESENTATION</span>
          </div>
          <div class="website-index-tips-c text-center color-1E1E1E">案例展示<span class="tips-block"></span></div>
        </div>
        <div class="case">
          <el-carousel indicator-position="outside" :interval="4000" :height="caseHeight">
            <el-carousel-item>
              <img :src="`${imgURI}/static/business/anli2.png`" class="aveter"/>
            </el-carousel-item>
            <el-carousel-item>
              <img :src="`${imgURI}/static/business/anli1.png`" class="aveter"/>
            </el-carousel-item>
            <el-carousel-item>
              <img :src="`${imgURI}/static/business/anli3.png`" class="aveter"/>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <div id="contact">
        <tips :tipsC="`联系我们`" :tipsE="`CONTACT US`" :paddingTop="183" :paddingBottom="80"></tips>
        <div class="contact-tips color-979797 font-14 text-center">
          不断倾听和满足客户需求引导并超越用户需求，赢得用户口碑推动互联网行业的<br/>
          健康发展，与合作伙伴共同成长，赢得行业口碑<br/>
          注重企业责任，关爱社会、回馈社会，赢得社会口碑<br/>
          提升企业地位与品牌形象，让员工具有高度的企业荣誉感和自豪感，赢得员工口碑
        </div>
        <div>
          <div class="contact-img display-flex justify-content-center align-items-center">
            <img :src="`../../static/business/erweima.png`">
          </div>
          <div class="contact-number color-292C2E font-14 text-center">商务对接：丹丫 18929394725</div>
        </div>
      </div>
    </div>
    <website-bot></website-bot>
  </div>
</template>

<script>
import WebsiteBot from '@/components/public/websiteBot'
import WebsiteHeader from '@/components/public/header'
import config from '@/config/index'
import tips from '@/components/public/tips'
export default {
  name: 'businessIndex',
  components: {WebsiteBot, WebsiteHeader, tips},
  data () {
    return {
      imgURI: config.imgURI,
      flowList: [
        {
          icon: 'dy.png'
        },
        {
          icon: 'sph.png'
        },
        {
          icon: 'bz.png'
        },
        {
          icon: 'zh.png'
        },
        {
          icon: 'wb.png'
        },
        {
          icon: 'tt.png'
        },
        {
          icon: 'xhs.png'
        }
      ],
      caseHeight: '438px',
      processList: [
        {
          icon: 'lc1.png',
          title: '确认客户需求'
        },
        {
          icon: 'lc2.png',
          title: '制定营销方案'
        },
        {
          icon: 'lc3.png',
          title: '达成合作'
        },
        {
          icon: 'lc4.png',
          title: '排期执行'
        },
        {
          icon: 'lc5.png',
          title: '整体运营'
        },
        {
          icon: 'lc6.png',
          title: '客户验收'
        },
        {
          icon: 'lc7.png',
          title: '数据回收'
        },
        {
          icon: 'lc8.png',
          title: '项目续签'
        }
      ]
    }
  },
  mounted () {
    // let type = 438 / 1920
    // this.caseHeight = (document.body.clientWidth * type) + 'px'
    if (this.$route.query.id) {
      this.goAnchor(this.$route.query.id)
    }
  },
  watch: {
    // 监听路由对象$route的变化
    '$route': {
      handler: function (to, from) {
        if (to) {
          this.goAnchor(to.query.id)
        }
      },
      deep: true
    }
  },
  methods: {
    goAnchor (id) {
      document.querySelector(`#${id}`).scrollIntoView({
        behavior: 'smooth'
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.business-index{
  .index-top{
    margin-top: -100px;
    width: 100%;
    height: 750px;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    .index-top-bor{
      padding-top: 180px;
      margin: 0 auto;
      width: 1200px;
    }
    .tips{
      font-size: 25px;
      color: #ffffff;
    }
    .tips-c{
      letter-spacing: 8px;
      font-size: 48px;
      font-weight: bold;
      color: #ffffff;
    }
  }
  .online-right{
    flex: 1;
    background: #FBFCFE;
    flex-direction: column;
    .line{
      margin-top: 6px;
      width: 30px;
      height: 0;
      background: #7F7F7F;
      border: 1px solid #7F7F7F;
    }
    .title{
      font-size: 24px;
      color: #2095EB;
      padding: 0px 0 10px 0;
    }
    .description{
      margin-top: 20px;
      line-height: 30px;
    }
  }
  .moss{
    margin-top: 300px;
    .title{
      font-size: 24px;
      color: #2095EB;
      padding: 0 0 10px 0;
    }
    .moss-bor{
      background: #FBFCFE;
      height: 286px;
    }
    .moss-ul{
      flex-direction: column;
      text-align: center;
      line-height: 26px;
    }
    .moss-img{
      width: 1200px;
      margin: -350px auto 0 auto;
      .user{
        float: right;
        width: 446px;
      }
    }
    .line{
      margin: 8px auto 30px auto;
      //margin-top: 6px;
      width: 30px;
      height: 0;
      background: #7F7F7F;
      border: 1px solid #7F7F7F;
    }
  }
  .flow{
    margin: 182px auto 210px auto;
    .flow-list{
      margin-top: 57px;
      gap: 70px;
    }
  }
  .msg-bor{
    padding-top: 128px;
    .msg-bor-left{
      float: left;
      padding: 0 40px;
      width: 500px !important;
      height: 307px;
      background: #FFFFFF;
      position: relative;
      z-index: 2;
      text-align: center;
      .title{
        margin-top: 90px;
        color: #3696E8;
      }
      .line{
        margin: 20px auto 20px auto;
        width: 30px;
        height: 0;
        background: #cccccc;
        border: 1px solid #cccccc;
      }
    }
  }
  .intro-carousel{
    width: 715px;
    float: right;
    z-index: 1;
  }
  .msg{
    letter-spacing: 0.5px;
    font-size: 14px;
    line-height: 30px;
  }
  .scope{
    .scope-one{
      margin: 0 25px 0 25px;
      flex-direction: column;
      align-items: center;
      font-size: 20px;
      width: 174px;
      height: 206px;
      background-image: url("/static/business/2.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      text-align: center;
      cursor: pointer;
    }
    .scope-one:hover{
      background-image: url("/static/business/1.png");
      color: #FFFFFF;
    }
  }
  .process-ul{
    gap: 92px;
    margin-bottom: 90px;
    li{
      width: 230px;
      padding: 50px 0 0 0;
      img{
        margin-bottom: 10px;
        height: 61px;
      }
    }
  }
  .process-ul li:nth-of-type(1){
    img{
      height: 51px;
    }
  }
  .process-ul li:nth-of-type(2){
    img{
      height: 49px;
    }
  }
  .process-ul li:nth-of-type(3){
    img{
      height: 50px;
    }
  }
  .process-ul li:nth-of-type(4){
    img{
      height: 50.77px;
    }
  }
  .website-index-tips{
    padding: 89px 0 0 0;
  }
  .website-index-tips-c{
    padding-bottom: 60px;
    font-size: 24px;
  }
  .tips-about{
    letter-spacing: 2px;
    font-size: 25px;
  }
  .tips-block{
    position: relative;
    top: 2px;
    margin-left: 6px;
    display: inline-block;
    width: 12px;
    height: 12px;
    background: #0685D9;
    border-radius: 2px 2px 2px 2px;
  }
  .case{
    .aveter{
      width: 100%;
      //height: 100%;
    }
  }
  .contact-tips{
    line-height: 30px;
  }
  .contact-img{
    border: 1px solid #1F8DF9;
    width: 160px;
    height: 160px;
    margin: 87px auto 0 auto;
    img{
      width: 152px;
      height: 152px;
    }
  }
  .contact-number{
    margin: 13px 0 77px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/business/index.vue